/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import ReportStageBar from '@/components/ReportStageBar/index.vue';
import ReportStageReport from '@/components/ReportStageReport/index.vue';
import ReportStageCheck from '@/components/ReportStageCheck/index.vue';
import ReportStageDetails from '@/components/ReportStageDetails/index.vue';
import ReportStageFinish from '@/components/ReportStageFinish/index.vue';
import IssuesList from '@/components/IssuesList/index.vue';
import {Action, State} from 'vuex-class';
import {Meta} from '@/decorators';
import {MetaInfo} from 'vue-meta';
import ContentBlock from '@/components/ContentBlock/index.vue';
import {FormStateInterface} from '@/store/modules/form/types';


/**
 * Report Issue page view (component).
 *
 *  * @author jgeorgiadou@frontier.co.uk
 */

@Component({
    name: 'v-report-issue',
    components: {
        'c-report-stage-bar': ReportStageBar,
        'c-report-stage-report': ReportStageReport,
        'c-report-stage-check': ReportStageCheck,
        'c-report-stage-details': ReportStageDetails,
        'c-report-stage-finish': ReportStageFinish,
        'c-issues-list': IssuesList,
        'c-content-block': ContentBlock,
    },
})

export default class ReportIssue extends Vue {
    // Update current view name in state
    @Action('updateCurrentView', {namespace: 'userSessionModule'})
    public updateCurrentView!: (view: {name: string, params?: any} | undefined) => void;

    // Form
    @State('formStateModule') public formState!: FormStateInterface;
    @Action('updatePageTitle', {namespace: 'settingsModule'}) public updatePageTitle!: (title: string) => void;
    @Action('cancelReportIssue', {namespace: 'formStateModule'}) public cancelReportIssue!: () => void;

    /**
     * Created lifecycle event.
     * Page should always return to step 1.
     */
    public created(): void {
        // todo: need more intelligent way of doing this - should only reset if menu link is clicked, not on refresh
        this.cancelReportIssue();
    }
    /**
     * Mounted life-cycle event.
     *
     * Initialises the loader.
     */
    public async mounted(): Promise<void> {
        this.updatePageTitle(this.$i18n.translate('menu.header.reportIssue', {}) || '');

        // Update current view name in state
        this.updateCurrentView({name: this.$router.currentRoute.name || 'home'});
    }

    /**
     * Meta generation.
     *
     *
     * This is an example cascaded meta generator for title and other met properties.
     *
     * @returns {MetaInfo}
     */
    @Meta
    public meta(): MetaInfo {
        const title: string = 'Submit report';

        return {
            title,
            meta: [
                {
                    property: 'og:title',
                    content: `${this.$i18n.translate('application.title', {}) || ''} - ${title}`,
                },
                {
                    property: 'og:description',
                    content: 'Submit a report on the issue you\'ve found.',
                },
                {
                    property: 'og:image',
                    content: window.location.hostname + '/img/og_image.jpg',
                },
            ],
        };
    }
}
